/**
 * Redirects destination URLs whose slashes were percent-encoded (`united-states%2Futah%2Fmoab`)
 * to their split form before the page loads. Such URLs arrive as one segment, so the page would
 * treat a city as a country and fetch its data with the wrong nearby settings.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (!hasEncodedDestinationSegments(to.params?.destinationPath)) {
    return
  }

  const localePath = useLocalePath()
  const getRouteBaseName = useRouteBaseName()

  const name = getRouteBaseName(to)?.toString() ?? ''
  const destinationPath = destinationPathSegments(to.params.destinationPath)

  return navigateTo(localePath({ name, params: { ...to.params, destinationPath }, query: to.query }), {
    redirectCode: 301,
  })
})
